"use strict";

define('uikit/collections/breadcrumb',['marionette', 'underscore', '../mixins/component.mixin', '../channel', '../extra/size', '../templates'], function (Mn, _, ComponentMixin, channel, Size, Templates) {
  var Breadcrumb = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'ui breadcrumb',
    template: Templates.UIKit['breadcrumb'],
    options: {
      visible: true,
      dividerIcon: null,
      divider: '/',
      size: ''
    },
    sizeOptionValues: _.values(Size),
    bindings: {
      text: 'text',
      link: 'link',
      icon: 'icon'
    },
    events: {
      'keydown .section': function keydown_Section(ev) {
        if (ev.keyCode == 13) {
          this.triggerSectionPress(ev);
        }
      },
      'click .section': 'triggerSectionPress'
    },
    update: {
      visible: false
    },
    onFirstRender: function onFirstRender() {
      if (this.collection) {
        this.listenTo(this.collection, 'add remove sort reset change', this._requestRender);
      }
    },
    serializeData: function serializeData() {
      var data = Mn.ItemView.prototype.serializeData.apply(this, arguments);
      data.items = _.map(data.items, function (item, index, list) {
        return {
          last: index == list.length - 1,
          first: index == 0,
          index: index,
          text: item[this.bindings.text],
          icon: item[this.bindings.icon],
          link: item[this.bindings.link],
          href: _.isString(item[this.bindings.link]) ? item[this.bindings.link] : null,
          dividerIcon: this.getOption('dividerIcon'),
          divider: this.getOption('divider')
        };
      }, this);
      return data;
    },
    triggerSectionPress: function triggerSectionPress(ev) {
      var el = $(ev.currentTarget),
        index = Number(el.data('index'));
      if (!_.isNaN(index)) {
        this.triggerMethod('section:press', this.collection.at(index), index);
      }
    },
    updateAttributes: function updateAttributes() {
      this.addClass(this.getOption('size'));
    }
  });
  channel.reply('breadcrumb', function () {
    return Breadcrumb;
  });
  return Breadcrumb;
});

